export const name = 'addLFCodeController';

export default function addLFCodeController(
  rnHttp,
  $state,
  $stateParams
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let myParams = {};

  let vm = this;
  vm.loading = true;
  vm.submitting = false;

  // controller functions
  vm.submit = submit;
  vm.cancel = cancel;

  activate();

  ////////////////////////
  function activate() {
    if ($stateParams.bu) {
      myParams.bu = $stateParams.bu;
      vm.bu = $stateParams.bu;
    }

    myParams.data = $stateParams.data;
    vm.loading = false;
  }

  function submit() {
    vm.submitting = true;
    delete vm.errorKey;


    let config = {
      headers: {
        'If-Modified-Since': undefined,
        'Cache-Control': undefined
      },
      params: {
        sc: vm.code
      },
    };
    return rnHttp.get('lf_cc', 'ValidatePrinterSC', config).then(resp => {
      if (resp.data.status === 'invalid') {
        vm.errorKey = 'register.register.InvalidCode';
        return;
      }

      _.set(myParams, 'lfCode', vm.code);
      $state.go('lf-add', myParams);
    })
      .catch(error => {
        vm.errorKey = 'register.register.InvalidCode';
      })
      .finally(() => {
        vm.submitting = false;
      });
  }

  function cancel() {
    $state.go('signin', myParams);
  }
}



// WEBPACK FOOTER //
// ./components/lf-code/lf-code.controller.js